import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $HelperContainerTitle = styled('div')`
  margin-bottom: ${spacing('lg')};
  h2 {
    font-weight: ${fontWeight('bold')};
    @media ${media.maxWidth.sm} {
      ${fontStyle('xl')};
    }
  }
`;

export const $HelperButton = styled(Button)`
  min-width: unset;
  overflow: unset;
  margin-bottom: ${spacing(1.5)};
  color: ${({ theme }) => theme.colors.black};
  &&:hover,
  &&:active,
  &&:focus {
    color: ${({ theme }) => theme.colors.primary};
    background-color: unset;
  }
`;

export const $Img = styled.img`
  width: 100%;
`;
